import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Divider, Grid, MenuItem, TextField, useMediaQuery } from "@mui/material"
import { get } from "lodash";
import { useTranslation } from "react-i18next"

export default function AutoCompletedCard({
    handleChange,
    cardTitle,
    options,
    value,
    label,
    loading,
    error,
    disabled = false,
    required = false,
    getOptionLabel = (option) => (option && option.name) ? option.name : '',
    openDialog = () => { },
    addNewRecord = false,
    addRecordLabel = "",
    menuOptionName="name"
}) {

    const { t } = useTranslation()

    const AddNewRecord = ({ children, ...props }) => {
        return <Box {...props}>
            <Button sx={{ textTransform: "none" }} fullWidth onClick={openDialog}>{t(addRecordLabel)}</Button>
            {children}
        </Box>
    }

    return (
        <Card>
            <CardHeader title={t(cardTitle)} />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs={12}>
                        <Autocomplete
                            // isOptionEqualToValue={(option, value) => option.id === value.id}
                            fullWidth
                            disabled={disabled}
                            getOptionLabel={getOptionLabel}
                            onChange={handleChange}
                            value={value ?? ""}
                            size="small"
                            loading={loading}
                            loadingText={t("loading data...")}
                            options={options}
                            renderInput={(params) => <TextField {...params}
                                label={t(label)}
                                error={!!error}
                                helperText={error ?? ''}
                                required={required}
                            />}
                            renderOption={(props, option) => (
                                <MenuItem
                                    {...props}
                                    key={option.id}
                                >
                                    {get(option, menuOptionName)}
                                </MenuItem>
                            )}
                            ListboxComponent={addNewRecord ? AddNewRecord : undefined}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
